import * as Yup from "yup";
// import { taxTypes as _taxTypes, taxTypesArray as _taxTypesArray, getDefaultTaxType, getTaxTypeByValue } from "../../configs/taxConfig"

// export const taxTypes = _taxTypes
// export const taxTypesArray = _taxTypesArray

// const taxType = getDefaultTaxType()

export const adjustmentTypes = {
    tax: "tax",
    discount: "discount",
    roundingCredit: "rounding_credit",
    roundingDebit: "rounding_debit"
}

export const validationRowSchema = Yup.object({
    type: Yup
        .string()
        .oneOf(Object.keys(adjustmentTypes).map(i => adjustmentTypes[i]))
        .required("Required"),
    description: Yup
        .string()
        .required("Required"),
    adjustment_amount: Yup
        .number()
        .required("Required"),
    adjustment_percentage: Yup
        .number()
        .required("Required"),
})

export const validationSchema = Yup.object({
    grossAmount: Yup
        .number()
        .typeError("Qty only number")
        .required("Required"),
    netAmount: Yup
        .number()
        .typeError("Qty only number")
        .required("Required"),
    rows: Yup.array().of(validationRowSchema)
})

export const initialRowValues = {
    adjustment_id: "",
    type: "",
    description: "",
    adjustment_amount: 0.00,
    adjustment_percentage: 0.00,
    refer_id: "",
}

export const initialValues = {
    netAmount: 0.00,
    grossAmount: 0.00,
    taxAmount: 0.00,
    discountAmount: 0.00,
    rows: [initialRowValues]
}

// during post or put action to api
// export const getTaxApiFormat = (tax) => {
//     return {
//         tax: {
//             tax_type: tax.value,
//             tax_percentage: tax.percentPoint,
//             tax_amount: tax.amount,
//             tax_description: tax.description
//         },
//     }
// }

// // during get or read the data from api
// export const readTaxApiFormat = (values) => {

//     // get the discount search by value
//     const current = getTaxTypeByValue(values?.tax_type)

//     if (!values?.tax_percent) return false;

//     return {
//         tax: {
//             ...current,
//             percentPoint: values?.tax_percent,
//             amount: values?.tax_amount,
//             description: values?.tax_description
//         },
//     }
// }

// export const getInitialTaxValues = (id, val) => {

//     const selectTax = taxTypesArray.filter(i => i.id === id)

//     const {
//         percentPoint = ''
//     } = selectTax.length ? selectTax[0] : {}

//     const amount = parseFloat(percentPoint / 100) * parseFloat(val)

//     return {
//         ...selectTax[0],
//         amount: amount.toFixed(2)
//     }

// }